module.exports = __webpack_public_path__ + "static/media/tools.a3090786.svg";